import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {System} from '../../shared-components/System';
import {HttpClient} from '@angular/common/http';
import {CourseTerm} from '../student-schedule/course-term.model';

@Injectable({
    providedIn: 'root'
})
export class CalendarService {

    constructor(private http: HttpClient) {
    }

    getCalendarEvents(studentId, yearId, userId, startDate): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCalendarEvents?studentId=${studentId}&yearId=${yearId}&userId=${userId}&startDate=${startDate}`);
    }

    getTermsForCourses(termDefinitionId: number, siteYearId: number): Observable<CourseTerm[]> {
        return this.http.get<CourseTerm[]>(System.apiURL.Counselor + 'GetTermsForCourses?termDefinitionId=' + termDefinitionId + '&siteYearId=' + siteYearId);
    }

}
